// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2Uqko","productName":"Table_productName__1HDks"};